export default "__VITE_ASSET__c061b64f__"